var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('header-desktop'),_c('main',{staticClass:"layoutMain main"},[_vm._t("default")],2),_c('Footer'),_c('NavbarMobile',{staticClass:"d-block d-lg-none"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }